export const firebaseConfig = {
    "projectId": "guidde-production-eu",
    "appId": "1:479143857377:web:0c790f4493f23549487ba0",
    "databaseURL": "https://guidde-production-eu-default-rtdb.europe-west1.firebasedatabase.app",
    "storageBucket": "guidde-production-eu.appspot.com",
    "locationId": "europe-west",
    "apiKey": "AIzaSyC_n-2owO4Ic6C7BJW8PM5q-BsGZWysyhI",
    "authDomain": "eu.guidde.com",
    "messagingSenderId": "479143857377",
    "projectNumber": "479143857377",
    "version": "2",
    "stiggApiKey": "client-beb97e25-643c-43e0-b743-fe6068e09717:0bd8f132-b309-46b2-b611-146a5c7a2d8f",
    "stiggEnv": "Production",
    "environment": "production"
}

export const BRAND_FETCH_CLIENT_KEY =
'1idzwFOduCW-kJxvD50'
export const ENABLE_SAOLA =
'false'
export const GDRIVE_PICKED_API_KEY =
'AIzaSyCd55DqzGUTO-hZ_2cTzC_VYAW7Rb_ikNU'
export const MIXPANEL_SESSION_REPLAY_PERCENT =
'10'
export const MIXPANEL_TOKEN =
'ce15fdc89e126278c35370cb0001d462'
export const MS_CLIENT_ID =
'c8dc8646-4144-40b1-90f2-5fda5f0b816b'
export const SAOLA_ACCOUNT_TOKEN =
'856f10ef-4168-4be6-8d73-06030e21a9a0'
export const STIGG_API_KEY =
'client-beb97e25-643c-43e0-b743-fe6068e09717:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const STIGG_BASE_URL =
'https://eu.guidde.com/stigg/api'
export const STIGG_CLIENT_KEY =
'client-beb97e25-643c-43e0-b743-fe6068e09717:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const STIGG_CLIENT_SDK_POLLING_INTERVAL_MS =
'10000'
export const STIGG_EDGE_URL =
'https://eu.guidde.com/stigg/api/edge'
export const STIGG_ENV =
'Production-EU'
export const WEB_CLIENT_ID =
'479143857377-bv0eo0og1k445robpc42hs5tk98nuho5.apps.googleusercontent.com'
export const entailApiKey =
'et-WJgibNJi14XN2kj8esMTq2ke_JhVpI8n5kq0lPv1-2eEnbIv'
export const isSeparateNetworkIssuesInMonitoring =
'true'
export const tapfiliateAccountId =
'38971-9bf427'